export const hanziStrokeAnimationTiming = {
  strokeAnimationDuration: 300,
  brushGrowthDuration: 100,
  delayBetweenStrokes: 200,
  delayBeforeStart: 250,
};
